import axios from 'axios'
import { refreshToken } from '@/api/login'
import { Message } from 'element-ui'
import Waiting from '../../components/waiting'
import router from '@/router'
import{ setCookieWithResidueTime, getCookie } from '@/utils/setCookie'
const server = axios.create({
  baseURL: process.env.VUE_APP_PROXY + '/admin-api/'
  // withCredentials: true
})

// Axios 无感知刷新令牌，参考 https://www.dashingdog.cn/article/11 与 https://segmentfault.com/a/1190000020210980 实现
// 请求队列
let requestList = []
// 是否正在刷新中
let isRefreshToken = false

/**
 * 请求拦截器
 */
server.interceptors.request.use(function (config) {
  config.headers.Authorization = 'Bearer ' + localStorage.getItem('token')
  // config.headers.Accesstoken = 'c56c1b4f05315664d34419536cbc5081'
  config.headers.contentType = "application/json";
  // get 请求映射 params 参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?'
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName]
      const part = encodeURIComponent(propName) + '='
      if (value !== null && value !== undefined) {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            const params = propName + '[' + key + ']'
            const subPart = encodeURIComponent(params) + '='
            url += subPart + encodeURIComponent(value[key]) + '&'
          }
        } else {
          url += part + encodeURIComponent(value) + '&'
        }
      }
    }
    url = url.slice(0, -1)
    config.params = {}
    config.url = url
  }

  return config
}, function (error) {
  return Promise.reject(error)
})

/**
 * 响应拦截器
 */
server.interceptors.response.use(async response => {
  if (response.data.code === 401) {
    if (!isRefreshToken) {
      isRefreshToken = true
      const token = localStorage.getItem('refreshToken')
      // 进行刷新访问令牌
      try {
        const { data: refreshTokenRes } = await refreshToken(token)
        localStorage.setItem('token', refreshTokenRes.accessToken)
        localStorage.setItem('refreshToken', refreshTokenRes.refreshToken)
        // 刷新成功，则回放队列的请求 + 当前请求
        requestList.forEach(cb => cb())
        return server(response.config)
      } catch (e) {
        // 刷新失败，只回放队列的请求
        // requestList.forEach(cb => cb())
        // 提示是否要登出。即不回放当前请求！不然会形成递归
        if (document.getElementsByClassName('el-message').length === 0) {
          Message({ type: 'error', message: '会话已过期，请重新登录' })
        }
        // router.push({ name: 'login' })
        // return false
      } finally {
        requestList = []
        isRefreshToken = false
      }
    } else {
      // 添加到队列，等待刷新获取到新的令牌
      return new Promise(resolve => {
        requestList.push(() => {
          // 让每个请求携带自定义 token 请根据实际情况自行修改
          response.config.headers.Authorization = 'Bearer ' + localStorage.getItem('token')
          resolve(server(response.config))
        })
      })
    }
  } else {
    if (response.headers.get('Content-Disposition')) {
      const filename = response.headers.get('Content-Disposition').match(/filename=(.*)/)[1]
      return { data: response.data, filename }
    }
    return response.data
  }
}, error => {
  switch (error.response.status) {
    case 401:
      if (document.getElementsByClassName('el-message').length === 0) {
        Message({ type: 'error', message: '会话已过期，请重新登录' })
      }
      // router.push({ name: 'login' })
      break
    case 422:
      if (document.getElementsByClassName('el-message').length === 0) {
        Message({ type: 'error', message: '有错误' })
      }
      break
    case 403:
      if (document.getElementsByClassName('el-message').length === 0) {
        Message({ type: 'error', message: '无权限' })
      }
      break
    case 500:
      if (document.getElementsByClassName('el-message').length === 0) {
        Message({ type: 'error', message: '服务器错误' })
      }
      break
  }
  Waiting.hidden()
  return Promise.reject(error)
})

export default server
